"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sticky = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var StickyScript_1 = require("./StickyScript");
var Sticky = function (props) {
    var children = props.children;
    if (window.CSS && CSS.supports('position', 'sticky')) {
        return (React.createElement("div", { className: "sticky-top" }, children));
    }
    else {
        // For browser witch do not support position: sticky
        return (React.createElement(StickyScript_1.StickyScript, null, children));
    }
};
exports.Sticky = Sticky;
exports.Sticky.propTypes = {
    children: PropTypes.element.isRequired,
};
